import { render, staticRenderFns } from "./HelpdeskList.vue?vue&type=template&id=62cbd83b&scoped=true"
import script from "./HelpdeskList.ts?vue&type=script&lang=ts&external"
export * from "./HelpdeskList.ts?vue&type=script&lang=ts&external"
import style0 from "./HelpdeskList.vue?vue&type=style&index=0&id=62cbd83b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cbd83b",
  null
  
)

export default component.exports